var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"cut-rule"}),_c('span',{staticClass:"cut-rule-message"},[_vm._v("选填信息")])])}]

export { render, staticRenderFns }